import React from "react";
import { motion } from "framer-motion";
import { Banknote, Handshake, Scale, LineChart, ArrowUpRight } from "lucide-react";

const items = [
  {
    slug: "funding",
    label: "Funding Solutions",
    sub: "Debt · Equity · Hybrid",
    icon: Banknote,
  },
  {
    slug: "ma",
    label: "Mergers & Acquisitions",
    sub: "Buy-side · Sell-side",
    icon: Handshake,
  },
  {
    slug: "valuation",
    label: "Valuations & TEV Studies",
    sub: "Company · Brand · TEV",
    icon: Scale,
  },
  {
    slug: "advisory",
    label: "Advisory & Research",
    sub: "Strategy · Modelling",
    icon: LineChart,
  },
];

export const ServiceQuickNav = () => {
  const go = (slug) => {
    const el = document.getElementById(`pillar-${slug}`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      aria-label="Service quick navigation"
      className="relative pt-24 md:pt-28 pb-6 bg-[#0A1C14]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4"
        >
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.button
                key={it.slug}
                onClick={() => go(it.slug)}
                data-testid={`quicknav-${it.slug}`}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.05 + i * 0.06 }}
                whileHover={{ y: -3 }}
                className="group relative overflow-hidden text-left rounded-md border border-brand-border bg-brand-surface hover:border-brand-accent/60 hover:bg-brand-elevated transition-all px-4 md:px-5 py-4 md:py-5"
              >
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                     style={{ background: "radial-gradient(90% 90% at 90% 10%, rgba(16,185,129,0.18), transparent 70%)" }} />

                <div className="relative flex items-start justify-between gap-3">
                  <div className="w-9 h-9 rounded-md bg-brand-primary/15 border border-brand-primary/30 flex items-center justify-center text-brand-accent shrink-0">
                    <Icon className="w-4 h-4" />
                  </div>
                  <ArrowUpRight className="w-4 h-4 text-white/30 group-hover:text-brand-accent group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                </div>

                <p className="relative mt-4 font-serif text-white text-lg md:text-xl tracking-tight leading-snug">
                  {it.label}
                </p>
                <p className="relative mt-1 text-[11px] md:text-xs uppercase tracking-[0.16em] text-white/45 group-hover:text-brand-accent transition-colors">
                  {it.sub}
                </p>
              </motion.button>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default ServiceQuickNav;
